import { render, staticRenderFns } from "./MyArtist.vue?vue&type=template&id=effb9b1c&scoped=true&"
import script from "./MyArtist.vue?vue&type=script&lang=js&"
export * from "./MyArtist.vue?vue&type=script&lang=js&"
import style0 from "./MyArtist.vue?vue&type=style&index=0&id=effb9b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effb9b1c",
  null
  
)

export default component.exports